/**
 * The only class-name builder in the package.
 *
 * Every wrapper composes Broadsheet's own classes through this function; none of them
 * accepts a `className` that could invent a parallel class, and none accepts `style`,
 * which is where raw hex and raw px would otherwise enter the codebase (design §13.2 —
 * oxlint's adherence rules match JSX string literals, so removing the prop removes the
 * category of violation rather than reporting it).
 */
export function classes(...parts) {
    return parts.filter((part) => typeof part === "string" && part !== "").join(" ");
}
//# sourceMappingURL=classes.js.map